import { createSlice } from '@reduxjs/toolkit';
import { IProposal } from 'types/proposal';
import {
  commitProposalVersion,
  isAuctionEditing,
  isLoading,
  isPbeDirty,
  isPbeValid,
  isProposalListLoading,
  isValidating,
  lotList,
  setChangedItemsIds,
  setInvalidFields,
  setIsDirty,
  setProposal,
  setShadowProposal,
  supplierStatuses,
  updateProposal,
  updateProposalBestPriceAndRating,
} from './reducer';
import { IProposalStore } from './types';

const initialState: IProposalStore = {
  isLoading: false,
  proposal: {} as IProposal,
  shadowProposal: {} as IProposal,
  trace: {} as IProposal,
  supplierStatuses: [],
  lotList: [],
  isProposalListLoading: false,
  isValidating: false,
  isPbeValid: true,
  invalidFields: {},
  changedItemsIds: [],
  isPbeDirty: false,
  isDirty: false,
  isAuctionEditing: false,
  priceVersion: 1,
};

const proposalSlice = createSlice({
  name: 'proposal',
  initialState,
  reducers: {
    isLoading,
    setProposal,
    updateProposal,
    updateProposalBestPriceAndRating,
    isValidating,
    supplierStatuses,
    lotList,
    isProposalListLoading,
    isPbeValid,
    commitProposalVersion,
    setInvalidFields,
    setChangedItemsIds,
    isPbeDirty,
    setIsDirty,
    setShadowProposal,
    isAuctionEditing,
  },
});

export const actions = proposalSlice.actions;
export const reducer = proposalSlice.reducer;
